module.exports = __webpack_public_path__ + "joy-static/media/let-it-throw.c454296a.png";